import { createFileRoute, redirect } from "@tanstack/react-router";

/** Die eigenen Aufgaben heißen seit dem 14.09.2026 „Mein Board" (/board) — alte Links laufen weiter. */
export const Route = createFileRoute("/_angemeldet/_mitarbeiter/aufgaben")({
	beforeLoad: () => {
		throw redirect({ to: "/board", search: {}, replace: true });
	},
});
